// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import { Link } from 'trpc-react-native-ui';

import { ItemsPickerButton } from '../../../components/common';
import I18n from '../../../lib/i18n';

type Props = {
  children?: React$Element<any>,
  first?: boolean,
  label?: string,
  linkLabel?: string,
  value?: string,
  onPress?: Function,
};

class ProfileItemsPickerButton extends Component<Props> {
  renderArrow = () => {
    const { linkLabel } = this.props;
    const text = linkLabel ? linkLabel : I18n.t('profile.changeProfileButton');

    return <Link text={text} style={styles.linkStyle} />;
  };

  render() {
    const renderArrow = this.props.onPress && this.renderArrow;

    return <ItemsPickerButton {...this.props} renderArrow={renderArrow} />;
  }
}

const styles = StyleSheet.create({
  linkStyle: {
    fontSize: 14,
    marginRight: 2,
  },
});

export default ProfileItemsPickerButton;
